import moment from 'moment';
import _ from 'underscore';
import parseError from '../../../parseError';
import { Toast } from '../../../../../../Notification';

const updateTourIndicator = async ({ state, userId, editTourIndicator, updateState, refreshPage }) => {
  const { resource, itemDetails } = state;
  const { tourIndicatorId, codeId, indicatorId, tourId, billable, jobElementId, cost, tourStartTime } = itemDetails;
  let parameters = {
    tourIndicatorId,
    codeId,
    indicatorId,
    tourId,
    updatingUserId: userId,
    billable: billable || false,
    jobElementId: jobElementId || 0,
    cost: cost || 0
  };
  const day = moment(tourStartTime).format('M/D/YYYY (ddd)');
  let notification = {type: 'success', message: 'Indicator Updated', description: `For ${resource.name} on ${day}`};
  try {
    await editTourIndicator(parameters);
  }
  catch(error) {
    if (!_.isEmpty(error)) {
      updateState({
        crudError: {
          failedAction: 'editTourIndicator',
          message: parseError(error)
        }
      });
      console.log(error);
      notification = {
        type: 'error',
        message: "Updating Indicator Error",
        description: `For [${resource.name} on ${day}]: ${parseError(error)}`
      };
    }
  }
  Toast(notification);
  refreshPage();
}

export default updateTourIndicator;



// WEBPACK FOOTER //
// ./src/Components/Schedule/LiveScheduleUpdate/utils/CRUD/tour/indicator/updateTourIndicator.js